<div class="container">
  <h4>Profile</h4>
  @if (userStore.isLoading()) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }

  <mat-tab-group (selectedIndexChange)="changeTab($event)">
    <mat-tab label="Edit Profile">
      <div class="profile-form-wrapper">
        <div class="profile-container">

          <form [formGroup]="form">
            <app-user-data formControlName="userData" [showLabels]="true" [performanceTypes]="performanceTypes"></app-user-data>
          </form>
          <div class="d-flex align-center justify-between">
            <button matButton="filled" class="button-secondary"  (click)="reset()">Reset Changes</button>
            <button matButton="filled" class="button-regular" [disabled]="form.invalid" (click)="save()">Save</button>
          </div>

        </div>


      </div>

    </mat-tab>
    <mat-tab label="Settings">
      <div class="profile-form-wrapper pt-24">
        <div class="profile-container">

          <form [formGroup]="changePasswordForm">
            <div class="pb-12">
              <div class="form-hint">Current password</div>
              <div class="custom-icon-input-container">
                <input type="{{isPasswordShown ? 'text' : 'password'}}" formControlName="oldPassword" placeholder="Current Password *" autocomplete="off">
                <mat-icon class="pointer" (click)="isPasswordShown = !isPasswordShown">{{isPasswordShown? 'visibility' : 'visibility_off'}}</mat-icon>
              </div>
              @if (changePasswordForm.controls.oldPassword.touched) {
                <div class="alert">

                  @if (changePasswordForm.controls.oldPassword.hasError('minlength')) {
                    <div class="form-validation-error">
                      Password should be at least 6 symbols long
                    </div>
                  }
                  @if (changePasswordForm.controls.oldPassword.hasError('pattern')) {
                    <div class="form-validation-error">
                      Password must contain at least one uppercase letter, one lowercase letter, one number and one special character
                    </div>
                  }
                </div>
              }
            </div>

            <div class="pb-12">
              <div class="form-hint">New password</div>
              <div class="custom-icon-input-container">
                <input type="{{isPasswordShown ? 'text' : 'password'}}" formControlName="password" placeholder="New Password *" autocomplete="off">
                <mat-icon class="pointer" (click)="isPasswordShown = !isPasswordShown">{{isPasswordShown? 'visibility' : 'visibility_off'}}</mat-icon>
              </div>
              @if (changePasswordForm.controls.password.touched) {
                <div class="alert">

                  @if (changePasswordForm.controls.password.hasError('minlength')) {
                    <div class="form-validation-error">
                      Password should be at least 6 symbols long
                    </div>
                  }
                  @if (changePasswordForm.controls.password.hasError('pattern')) {
                    <div class="form-validation-error">
                      Password must contain at least one uppercase letter, one lowercase letter, one number and one special character
                    </div>
                  }
                </div>
              }
            </div>

            <div class="pb-12">
              <div class="form-hint">Confirm new password</div>
              <div class="custom-icon-input-container">
                <input type="{{isPasswordShown ? 'text' : 'password'}}" formControlName="passwordConfirm" placeholder="Password confirm *" autocomplete="off">
                <mat-icon class="pointer" (click)="isPasswordShown = !isPasswordShown">{{isPasswordShown? 'visibility' : 'visibility_off'}}</mat-icon>
              </div>
              @if (changePasswordForm.controls.passwordConfirm.touched) {
                <div class="alert">

                  @if (form.hasError('passwordMismatch')) {
                    <div class="form-validation-error">
                      Passwords should mach
                    </div>
                  }
                </div>
              }
            </div>

          </form>
          <div class="d-flex align-center justify-between">
            <button matButton="filled" class="button-regular w-100" [disabled]="changePasswordForm.invalid || userStore.isLoading()" (click)="changePassword()">Save</button>
          </div>

          <hr style="margin: 24px 0">

          @if (!userStore.isLoading()) {
            <button matButton="filled" class="warning-button w-100" (click)="resetSubscription()">Cancel Subscription</button>

            <hr style="margin: 24px 0">

            <button matButton="filled" class="button-regular w-100" [disabled]="currentSubscriptionId === ''" (click)="changeSubscription()">Change Subscription</button>
          }


        </div>

      </div>

    </mat-tab>

    <mat-tab label="Billing History" >
      <div class="billing-history">
        @for (item of billingHistory; track item.id) {
          <div class="billing-item">
            <span>{{item.description}}</span>
            <span>${{item.amountDollars}}</span>
            <span>{{item.created | date: 'dd/MM/yy'}}</span>
            <a href="{{item.hostedInvoiceUrl}}" target="_blank">Open invoice <mat-icon>open_in_new</mat-icon></a>
            <a href="{{item.invoicePdf}}" target="_blank">download PDF <mat-icon>picture_as_pdf</mat-icon></a>

          </div>
        }
      </div>
    </mat-tab>

  </mat-tab-group>
</div>



